import t from "../../_styles/common/light.js";
function a(o) {
  const {
    primaryColor: r,
    errorColor: n
  } = o;
  return {
    colorError: n,
    colorLoading: r,
    height: "2px"
  };
}
const i = {
  name: "LoadingBar",
  common: t,
  self: a
}, g = i;
export {
  g as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/loading-bar/styles/light.js
// module id = 1711
// module chunks = 67